import _objectWithoutProperties from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _typeof from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/typeof.js";
var _excluded = ["id", "callback"],
    _excluded2 = ["children"];
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import CommentForm from "./components/CommentForm";
import CommentList from "./components/CommentList";
import CommentItem from "./components/CommentItem";
import VoteModel from "../VoteModel.vue";
export default {
  name: "Comment",
  components: {
    CommentList: CommentList,
    CommentItem: CommentItem,
    CommentForm: CommentForm,
    VoteModel: VoteModel
  },
  inheritAttrs: false,
  props: {
    /* 数据 */
    data: {
      type: Array,
      "default": function _default() {
        return [];
      },
      required: true
    },
    rootPost: {
      type: Object,
      "default": function _default() {},
      required: true
    },

    /* 当前用户 */
    user: {
      type: Object,
      "default": function _default() {},
      required: true
    },

    /* 配置属性 */
    props: {
      type: Object,
      "default": function _default() {}
    },

    /* 提交表单前事件 */
    beforeSubmit: {
      type: Function,
      required: true
    },

    /* 执行点赞前事件 */
    beforeLike: {
      type: Function,
      required: true
    },

    /* 执行删除前事件 */
    beforeDelete: {
      type: Function,
      required: true
    },

    /* 上传图片 */
    uploadImg: {
      type: Function,
      required: true
    }
  },
  emits: ["update:data"],
  data: function data() {
    return {
      forms: [],
      // 显示在视图上的所有表单 id
      cacheData: [],
      showModel: false,
      currentId: 0,
      blogs: {}
    };
  },
  computed: {
    computedProps: function computedProps(_ref) {
      var props = _ref.props;
      if (!props) return null;
      var entries = Object.entries(props);
      return entries.length > 0 ? entries : null;
    }
  },
  created: function created() {
    var _this = this;

    // 监听并执行一次
    var cancel = this.$watch("data", function () {
      _this.processData();

      cancel && cancel();
    });
  },
  methods: {
    /**
     * 处理初始数据
     */
    processData: function processData() {
      this.cacheData = this.data.map(this.comparePropsAndValues);
    },

    /** 对比和检查每条评论对象字段值 */
    comparePropsAndValues: function comparePropsAndValues(comment) {
      // 初始对象
      var originObj = {
        id: "",
        content: "",
        imgSrc: "",
        children: [],
        likes: 0,
        reply: null,
        createAt: null,
        user: {},
        liked: false,
        voters: []
      }; // 赋值

      for (var key in originObj) {
        originObj[key] = comment[this.props[key]] || comment[key] || originObj[key]; // 校验

        this.validate({
          key: key,
          value: originObj[key]
        });
      }

      if (originObj.children.length > 0) {
        originObj.children = originObj.children.map(this.comparePropsAndValues);
      }

      return originObj;
    },

    /** 校验数据 */
    validate: function validate(_ref2) {
      var key = _ref2.key,
          value = _ref2.value;
      var map = {
        user: {
          validate: function validate(v) {
            return (_typeof(v) !== "object" || JSON.stringify(v) === "{}") && this.message;
          },
          message: "User must be an object with props."
        },
        reply: {
          validate: function validate(v) {
            return _typeof(v) !== "object" && this.message;
          },
          message: "Reply must be an object"
        },
        children: {
          validate: function validate(v) {
            return !Array.isArray(v) && this.message;
          },
          message: "Children must be an array"
        },
        createAt: {
          validate: function validate() {
            return new Date(value).toString() === "Invalid Date" && this.message;
          },
          message: "CreateAt is not a valid date."
        }
      };
      var target = map[key];
      if (!target) return;
      var res = target.validate(value);

      if (res) {
        throw new Error("validate(): ".concat(res));
      }
    },

    /**
     * 将更新后的数组中的对象数据转换为初始对象结构
     */
    transformToOriginObj: function transformToOriginObj(comment) {
      try {
        var _comment = JSON.parse(JSON.stringify(comment));

        if (_comment.children && _comment.children.length > 0) {
          _comment.children = _comment.children.map(this.transformToOriginObj);
        } // 返回 props 中自定义的字段名


        if (!this.computedProps) return _comment;

        var _iterator = _createForOfIteratorHelper(this.computedProps),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (key !== value && Object.hasOwnProperty.call(_comment, key)) {
              _comment[value] = JSON.parse(JSON.stringify(_comment[key]));
              delete _comment[key];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return _comment;
      } catch (e) {
        console.error(e);
      }
    },

    /**
     * 判断是否已存在该id的表单，存在删除该表单，不存在则新增该表单，并触发其他表单blur事件
     */
    hasForm: function hasForm(id) {
      this.forms.includes(id) ? this.deleteForm(id) : this.addForm(id);
    },

    /**
     * 增加新表单
     */
    addForm: function addForm(id) {
      this.forms.push(id); // this.scrollIntoView(`${id}-form`)
    },

    /** 删除表单 */
    deleteForm: function deleteForm(id) {
      var index = this.forms.indexOf(id);
      index > -1 && this.forms.splice(index, 1);
    },

    /**
     * 评论或回复
     */
    formSubmit: function formSubmit(_ref3) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref3$newComment, id, callback, params, _ref3$parent, parent, _params, data, add;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref3$newComment = _ref3.newComment, id = _ref3$newComment.id, callback = _ref3$newComment.callback, params = _objectWithoutProperties(_ref3$newComment, _excluded), _ref3$parent = _ref3.parent, parent = _ref3$parent === void 0 ? null : _ref3$parent;
                _params = Object.assign(params, {
                  user: _this2.user
                }); // 等待外部提交事件执行

                if (!(typeof _this2.beforeSubmit === "function")) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 3;
                data = _this2.transformToOriginObj(_params);

                add = function add(data) {
                  _this2.addComment(id, _this2.comparePropsAndValues(data));

                  callback();
                };

                _context.next = 8;
                return _this2.beforeSubmit(data, parent, add);

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                console.error(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    closeModel: function closeModel() {
      this.showModel = false;
    },
    votePost: function votePost() {
      this.storeLikes(this.currentId);
    },
    handleCommentLike: function handleCommentLike(_ref4) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, _ref4$comment, children, params, _params;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref4.id, _ref4$comment = _ref4.comment, children = _ref4$comment.children, params = _objectWithoutProperties(_ref4$comment, _excluded2);
                _params = Object.assign(params, {
                  currentUser: _this3.user
                });

                if (typeof _this3.beforeLike === "function") {
                  try {
                    _this3.currentId = id;
                    _this3.showModel = true;
                    _this3.blogs.author = _params.user.name;
                    _this3.blogs.permlink = _params.user.permlink;
                    _this3.blogs.active_votes = _params.voters;

                    _this3.$refs.voteModel.openModel(); //await this.beforeLike(this.transformToOriginObj(_params));

                  } catch (e) {
                    console.error(e);
                  }
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * 删除评论或回复
     */
    handleCommentDelete: function handleCommentDelete(_ref5) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, comment, _ref5$parent, parent, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _ref5.id, comment = _ref5.comment, _ref5$parent = _ref5.parent, parent = _ref5$parent === void 0 ? null : _ref5$parent;

                if (!(typeof _this4.beforeDelete === "function")) {
                  _context3.next = 12;
                  break;
                }

                _context3.prev = 2;
                data = _this4.transformToOriginObj(comment);
                _context3.next = 6;
                return _this4.beforeDelete(data, parent);

              case 6:
                _this4.deleteComment(id);

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 9]]);
      }))();
    },

    /**
     * 保存点赞
     */
    storeLikes: function storeLikes(id) {
      var _this$getIndex = this.getIndex(id),
          commentIndex = _this$getIndex.commentIndex,
          replyIndex = _this$getIndex.replyIndex;

      var comment = this.cacheData[commentIndex];

      if (!isNaN(replyIndex)) {
        comment = comment.children[replyIndex];
      }

      comment.liked = !comment.liked;

      if (comment.likes) {
        comment.liked ? comment.likes++ : comment.likes--;
      } else {
        comment.likes = 1;
      }

      var data = this.cacheData.map(this.transformToOriginObj);
      this.$emit("update:data", data);
    },

    /**
     * 存储新评论或回复
     */
    addComment: function addComment(id, rawData) {
      var _this$getIndex2 = this.getIndex(id),
          commentIndex = _this$getIndex2.commentIndex; // 更新视图


      if (commentIndex === "root") {
        this.cacheData.push(rawData);
      } else {
        var comment = this.cacheData[commentIndex];
        comment.children.push(rawData);
      } // 滚动至可见视图上


      var signal = commentIndex === "root" ? this.cacheData.length - 1 : "".concat(commentIndex, "-").concat(this.cacheData[commentIndex].children.length - 1);
      this.scrollIntoView("comment-".concat(signal)); // 更新外部数据

      var data = this.cacheData.map(this.transformToOriginObj);
      this.$emit("update:data", data);
    },

    /**
     * 删除评论或回复
     */
    deleteComment: function deleteComment(id) {
      var _this$getIndex3 = this.getIndex(id),
          commentIndex = _this$getIndex3.commentIndex,
          replyIndex = _this$getIndex3.replyIndex;

      this.cacheData = this.cacheData.filter(function (c, i) {
        if (isNaN(replyIndex)) {
          return i !== commentIndex;
        } else {
          c.children = c.children.filter(function (r, j) {
            return j !== replyIndex;
          });
          return c;
        }
      });
      var data = this.cacheData.map(this.transformToOriginObj);
      this.$emit("update:data", data);
    },

    /**
     * 从id中提取出序号
     */
    getIndex: function getIndex(id) {
      var _id$split = id.split("-"),
          _id$split2 = _slicedToArray(_id$split, 3),
          c = _id$split2[1],
          r = _id$split2[2];

      return {
        commentIndex: c === "root" ? c : +c,
        replyIndex: +r
      };
    },

    /**
     * 将子组件滚动到视图可见区域
     */
    scrollIntoView: function scrollIntoView(ref) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs[ref][0].$el.scrollIntoView(false);
      });
    }
  }
};